var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77532 4.87022H8.09813V8.2246H4.74375V9.90179H8.09813V13.2562H9.77532V9.90179H13.1297V8.2246H9.77532V4.87022ZM8.93673 0.677246C4.30769 0.677246 0.550781 4.43415 0.550781 9.06319C0.550781 13.6922 4.30769 17.4491 8.93673 17.4491C13.5658 17.4491 17.3227 13.6922 17.3227 9.06319C17.3227 4.43415 13.5658 0.677246 8.93673 0.677246ZM8.93673 15.7719C5.23853 15.7719 2.22797 12.7614 2.22797 9.06319C2.22797 5.36499 5.23853 2.35444 8.93673 2.35444C12.6349 2.35444 15.6455 5.36499 15.6455 9.06319C15.6455 12.7614 12.6349 15.7719 8.93673 15.7719Z",
    fill: "#26405E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/round-plus.2621d8935c1b0ce57563c944a3a40ee0.svg";
export { ForwardRef as ReactComponent };